import React, { Component } from 'react'
import { Button, Spin, Form, Select, DatePicker, InputNumber } from 'antd';
import { Link } from 'dva/router'
import { connect } from 'dva'
import moment from 'moment'
import { all, get } from '../../services/restApi'
import { getTotal, getExcerpt } from '../../utils'
import config from '../../utils/config'
import Currency from 'react-currency-formatter';
var Icon = require('react-fontawesome');
const _ = require('underscore');

const FormItem = Form.Item;
const Option = Select.Option;

class Book extends Component {

    constructor (props) {
        super(props);

        this.state = {
            category: {},
            activities: [],
            book: {},
            hours: []
        };
    }


    /**
    * Inicialización
    */
    componentDidMount () {
        this.props.dispatch({type: 'app/showLoadingTable'})

        get('Category', this.props.location.query.book).then((resp) => {

            this.setState({ category: resp });
            this.getActivities();
        })
    }


    /**
    * Obtiene los tours
    */
    getActivities () {
        all('Activity', {
            where: {
                active: true,
                category: {__type: 'Pointer', className: 'Category', objectId: this.props.location.query.book}
            },
            include: 'category',
            limit: 1000
        }).then((resp) => {
            this.props.dispatch({type: 'app/hideLoadingTable'})

            this.setState({ activities: resp.results });
        })
    }


    /**
    * Cuando se elije la actividad, se consulta el tour de esa actividad (horarios y cupos)
    */
    handleSelectActivityChange (value) {
        this.props.dispatch({type: 'app/showLoadingTable'})

        all('Tour', {
            where: {
                activity: {__type: 'Pointer', className: 'Activity', objectId: value.key}
            },
            include: 'activity'
        }).then((resp) => {
            this.props.dispatch({type: 'app/hideLoadingTable'})

            let hours = _.filter(resp.results[0].hours, (i) => { return i.pax > 0 });

            this.setState({
                book: {tour: resp.results[0]},
                hours: hours
            });

            console.log(this.state.book);
        });
    }


    /**
    * Validator: Checa que se haya elegido un registro de la lista
    */
    checkActivity (rule, value, callback) {
        if (value && !value.label) {
            callback('Por favor, elija la actividad');
        } else {
            callback();
        }
    }


    /**
    * Cuando la fecha cambia
    */
    handleDateChange (value) {
        this.setState({
            book: {...this.state.book, date: {__type: 'Date', iso: new Date(value).toISOString()}}
        })
    }


    /**
    * Cuando el horario cambia
    */
    handleSelectHourChange (value) {
        if (value && value.key) {
            let hour = _.find(this.state.hours, {id: value.key});

            this.setState({ 
                book: {...this.state.book, hour: hour}
            });
        }
    }

    /**
    * Cuando la fecha cambia
    */
    handlePaxChange (value) {
        this.setState({
            book: {...this.state.book, pax: value}
        })
    }


    /**
    * Validación pax
    */
    checkPax (rule, value, callback) {
        console.log(value);
        if (value && value == 0) {
            callback('Por favor, ingrese el número de personas');
        } else {
            callback();
        }
    }


    disabledDate (current) {
        let calendarDate = moment(current).format('DD-MM-YYYY');


        if (this.state.book && !this.state.book.tour) {
            // Bloquear todos los días si no se ha elegido la actividad
            return true;

        } else {
            let tour = this.state.book.tour;

            if (current < moment().startOf('day')) {
                // Bloquear días anteriores al día de hoy
                return true;

            } else {
                // Bloquear días dependiendo a la disponibilidad del tour
                    
                // Verificamos si el día que se eligió se encuentra entre los días bloqueados
                let days_disabled = _.find(tour.days_disabled, {date: calendarDate});

                if (days_disabled) {
                    // Bloqueamos el día si aparece en la lista de bloqueados
                    return true;

                } else {

                    console.log(calendarDate);
                    console.log(moment(tour.date.iso).day());
                    console.log(moment(calendarDate).day());
                    console.log('-------------------------');
                    
                    // Se habilitan las fechas que cumplan con la periodicidad del tour (días disponibles)
                    if (moment(tour.date.iso).format('DD-MM-YYYY') === calendarDate ||
                        (tour.repeat && tour.periodicity === 'Diariamente') ||
                        (tour.repeat && tour.periodicity === 'Semanalmente' && moment(tour.date.iso).day() === moment(calendarDate, 'DD-MM-YYYY').day()) ||
                        (tour.repeat && tour.periodicity === 'Mensualmente' && moment(tour.date.iso).date() === moment(calendarDate, 'DD-MM-YYYY').date()) ||
                        (tour.repeat && tour.periodicity === 'Anualmente' && moment(tour.date.iso).format('DD-MM') === moment(calendarDate, 'DD-MM-YYYY').format('DD-MM'))) {
                        return false;

                    } else {
                        // Si no cumple con niguna de las anteriores se bloquea el día
                        return true;
                    }
                }
            }
        }
    }


    /**
    * Formulario
    */
    handleSubmit (e) {
        e.preventDefault();

        this.props.form.validateFieldsAndScroll((errors, values) => {
            if (errors) { return }

            console.log(values);
        });
    }


    /**
    * Render del componente
    */
    render () {
        const activities_options = this.state.activities.map(d => <Option key={d.objectId} label={d.name}>{d.name} - <Currency quantity={d.price ? d.price : 0} currency="USD" /></Option>)
        const hours_options = this.state.hours.map(d => <Option key={d.id} label={d.minHour +" - "+ d.maxHour}>{d.minHour} - {d.maxHour}</Option>)

        return (
            <div className="row">
                <Form onSubmit={this.handleSubmit.bind(this)}>
                    <Spin spinning={this.props.app.loadingTable}>
                        <div className="col-md-12">
                            <h2 className="marginBottom10">{this.state.category.name}</h2>
                            <p>Registre todos los datos obligatorios para generar su reservación</p>

                            <div className="col-sm-8 marginTop30">
                                <FormItem label="Actividad" hasFeedback>
                                    {this.props.form.getFieldDecorator('activity', {
                                        rules: [{
                                            required: true,
                                            message: 'Por favor, elija la actividad',
                                        }, {
                                            validator: this.checkActivity.bind(this)
                                        }]
                                    })(
                                        <Select 
                                            size='large'
                                            filterOption={false}
                                            labelInValue={true}
                                            optionLabelProp='label'
                                            onChange={this.handleSelectActivityChange.bind(this)}
                                            >
                                            {activities_options}
                                        </Select>
                                    )}
                                </FormItem>

                                <FormItem label="Fecha" hasFeedback>
                                    {this.props.form.getFieldDecorator('date', {
                                        rules: [{
                                            required: true,
                                            message: 'Por favor, elija la fecha',
                                        }]
                                    })(
                                        <DatePicker
                                            format="DD-MM-YYYY"
                                            disabledDate={this.disabledDate.bind(this)}
                                            onChange={this.handleDateChange.bind(this)}
                                        />
                                    )}
                                </FormItem>

                                {this.props.form.getFieldValue('date')
                                    ? <FormItem label="Horario" hasFeedback>
                                        {this.props.form.getFieldDecorator('hour', {
                                            rules: [{
                                                required: true,
                                                message: 'Por favor, elija el horario',
                                            }]
                                        })(
                                            <Select 
                                                size='large'
                                                filterOption={false}
                                                labelInValue={true}
                                                optionLabelProp='label'
                                                onChange={this.handleSelectHourChange.bind(this)}
                                                >
                                                {hours_options}
                                            </Select>
                                        )}
                                    </FormItem>
                                    : ''
                                }

                                {this.state.book.hour
                                    ? <FormItem label="Personas" hasFeedback>
                                        {this.props.form.getFieldDecorator('pax', {
                                            rules: [{
                                                required: true,
                                                message: 'Por favor, ingrese el número de personas',
                                            }]
                                        })(
                                            <InputNumber 
                                                min={1} 
                                                max={this.state.book.hour.pax} 
                                                onChange={this.handlePaxChange.bind(this)}
                                                className="ant-input ant-input-lg" />
                                        )}
                                    </FormItem>
                                    : ''
                                }

                                <Button type="primary" className="marginTop20">
                                    <Link onClick={this.handleSubmit.bind(this)}><Icon name="book" /> Reservar</Link>
                                </Button>
                            </div>

                            <div className="col-sm-4 marginTop30 box-resume nopadding">
                                <div className="box-resume-header text-center">
                                    Resumen
                                </div>

                                <div className="box-resume-content">
                                    <div className="row">
                                        <div className="col-xs-6">Tour:</div>
                                        <div className="col-xs-6 text-right">
                                            <span className="text-bold">{this.state.book.tour ? this.state.book.tour.activity.name : ''}</span>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-xs-6">Fecha:</div>
                                        <div className="col-xs-6 text-right">
                                            <span>{this.state.book.date ? moment(this.state.book.date).format('DD-MM-YYYY') : ''}</span>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-xs-6">Horario:</div>
                                        <div className="col-xs-6 text-right">
                                            <span>{this.state.book.hour ? this.state.book.hour.minHour + ' - ' + this.state.book.hour.maxHour : ''}</span>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-xs-6">Pax:</div>
                                        <div className="col-xs-6 text-right">
                                            <span>{this.state.book.pax ? this.state.book.pax + ' personas' : ''}</span>
                                        </div>
                                    </div>

                                    <div className="row marginTop20">
                                        <div className="col-xs-6 paddingTop10" style={{borderTop: '1px solid #f3f3f3'}}>
                                            Total&nbsp;
                                            <small>
                                                (<Currency quantity={this.state.book.tour ? this.state.book.tour.activity.price : 0} currency="USD" /> x {this.state.book.pax ? this.state.book.pax : 0})
                                            </small>
                                            :
                                        </div>

                                        <div className="col-xs-6 text-right paddingTop10" style={{borderTop: '1px solid #f3f3f3'}}>
                                            <span><Currency quantity={this.state.book.tour && this.state.book.pax ? this.state.book.tour.activity.price * this.state.book.pax : 0} currency="USD" /></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Spin>
                </Form>
            </div>
        )
    }
}

export default connect(({app}) => ({app}))(Form.create()(Book))


// WEBPACK FOOTER //
// ./src/components/widget/book.js